import { createStore, createHook } from "react-sweet-state";

const initialState = {
  schoolId: null,
  schoolName: "",
  schoolDescription: "",
  categories: [],
  schoolRoles: [],
}

const SchoolStore = createStore({
  initialState,
  actions: {
    initSchool: initialState => ({ setState }) =>  setState(initialState),
    onSelectSchool: 
    ({ 
      schoolId, 
      schoolName, 
      schoolDescription,
      roles,
      categories,
      faculties,
      departments,
      levels,
      grades
    }) => 
    ({ setState }) => {
      setState({
        schoolId: schoolId,
        schoolName: schoolName,
        schoolDescription: schoolDescription,
        schoolRoles: roles,
        categories: categories,
        faculties: faculties,
        departments: departments,
        levels: levels,
        grades: grades
      });
    },
    resetSchool: () => ({ setState }) => { setState({ ...initialState });
    },
  },
  name: "school"
 });

export const useSchoolStore = createHook(SchoolStore);
